module.exports = __webpack_public_path__ + "img/industry.ae81d395.png";